import { render, staticRenderFns } from "./TagSelection.vue?vue&type=template&id=78735c28&scoped=true"
import script from "./TagSelection.vue?vue&type=script&lang=js"
export * from "./TagSelection.vue?vue&type=script&lang=js"
import style0 from "./TagSelection.vue?vue&type=style&index=0&id=78735c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78735c28",
  null
  
)

export default component.exports